module.exports = __webpack_public_path__ + "assets/img/k-c-2.8bdc401e.png";